import { tween, easing, timeline } from 'popmotion'
import baseMixin from './baseMixin'

export default {
    mixins: [baseMixin],

    beforeCreate() {
        this.baseElementQueryString = 'external-data-graphic'
    },

    methods: {
        setStyler() {
            this.stylers = this.stylerGroup('#rows-1, #rows-2, #rows-3')
        },

        initAction() {
            return tween({
                from: { opacity: 1 },
                to: { opacity: 0 },
                ease: easing.linear,
                duration: 300
            })
        },

        initReaction(v) {
            this.stylers.forEach(s => s.set(v))
        },

        animationAction() {
            return timeline([
                {
                    track: 'row1',
                    from: { opacity: 0, x: -50, y: 30 },
                    to: { opacity: 1, x: 0, y: 0 }
                },
                {
                    track: 'row2',
                    from: { opacity: 0, x: 45, y: 25 },
                    to: { opacity: 1, x: 0, y: 0 }
                },
                {
                    track: 'row3',
                    from: { opacity: 0, x: -40, y: 20 },
                    to: { opacity: 1, x: 0, y: 0 }
                }
            ])
        },

        animationReaction(values) {
            this.stylers[0].set(values.row1)
            this.stylers[1].set(values.row2)
            this.stylers[2].set(values.row3)
        }
    }
}
